import { pickedApiRequest } from '@/api/request'

// A result must be rendered and visible. Candidate visits and locked previews never count.
export default {
  mounted() {
    this.resultWatchStop = this.$watch(() => {
      const a = this.exam && this.exam.attempt
      return a ? `${a.attemptId}:${a.unlockedAt}` : ''
    }, () => this.startResultObservation(), { immediate: true })
  },
  methods: {
    startResultObservation() {
      if (this.resultObservationCleanup) this.resultObservationCleanup()
      if (process.env.VUE_APP_SATELLITE !== 'testcandidates' || !window.IntersectionObserver) return
      let visible = false; let delivered = false; let pending = false; let destroyed = false; let retries = 0; let timer
      const send = async () => {
        if (destroyed || delivered || pending || !visible || document.visibilityState !== 'visible') return
        const attempt = this.exam && this.exam.attempt
        const organisation = this.$store.getters['employers/organisationId']
        if (!organisation || !attempt || !attempt.attemptId || !attempt.unlockedAt) return
        pending = true
        try {
          await pickedApiRequest.post(`assessment/organisations/${organisation}/result-opened`, { attemptId: attempt.attemptId }, { timeout: 10000 })
          delivered = true
          observer.disconnect()
        } catch (_) {
          if (!destroyed && retries < 3) timer = setTimeout(send, [1000, 5000, 15000][retries++])
        } finally { pending = false }
      }
      const observer = new IntersectionObserver(entries => {
        visible = entries.some(entry => entry.isIntersecting)
        send()
      })
      document.addEventListener('visibilitychange', send)
      window.addEventListener('online', send)
      observer.observe(this.$el)
      this.resultObservationCleanup = () => {
        destroyed = true
        clearTimeout(timer)
        observer.disconnect()
        document.removeEventListener('visibilitychange', send)
        window.removeEventListener('online', send)
      }
    }
  },
  beforeDestroy() {
    if (this.resultWatchStop) this.resultWatchStop()
    if (this.resultObservationCleanup) this.resultObservationCleanup()
  }
}
